/// <summary>
/// This visual provides a list of user comments<br/>
/// </summary>  
/// <remarks>
/// Author: MKU<br/>
/// Date: 01.06.2026<br/>
/// Copyright ©: EUDT GmbH 2026 <br/>
/// Version-History:<br/>
/// **********************************************************************<br/>
/// *** v1.1.0 - 09.06.2026 - MKU                                      ***<br/>
/// **********************************************************************<br/>
/// * - Added "Ich bin markiert" checkbox and custom logic to filter    *<br/>
/// * - Reduced text filter width to 30% in CSS                         *<br/>
/// *--------------------------------------------------------------------*<br/>
/// * - Removed "Projekt" column and realigned remaining widths to:     *<br/>
/// *   w5 (Icon), w60 (Notification), w35 (Comments)                    *<br/>
/// * - Appended project name in parentheses when blid is -1             *<br/>
/// **********************************************************************<br/>
jQuery.widget("bluaul.UserNotificationCommentList", jQuery.common.vcBaseV4, {
    vcV: new vcVisual(), // Instantiate vcVisual for Ticket Dialog Popups

    _create: function () {
        this._createVisual(404);
        this._super();
    },

    _initHTML: function () {
        var me = this;
        try {
            me._setRoot(".vc-user-notification-comment-list");
            me._buildHtml();
            me._setHeightsAndWidths();
            me._fetch();

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {

            // Initialize vcFilter widget for search filtering
            me.myHtml.header.topmenu.filter.vcFilter({ callback: function () { me._filterEntries(); } });

            // Event handler for the "I am marked" checkbox
            me.myHtml.header.topmenu.chkMarked.off("change").on("change", function () {
                me._filterEntries();
            });

            // showRead checkbox for admins to toggle visibility of read comments
            if (me.specific.isAdmin && me.myHtml.header.topmenu.chkShowRead) {
                me.myHtml.header.topmenu.chkShowRead.off("change").on("change", function () {
                    me._fetch();
                });
            }

            // Info icon click handler to open the ticket dialog in a popup
            me.myHtml.list.entries.off("click", ".info-assign").on("click", ".info-assign", function (e) {
                e.stopPropagation(); // Stop event bubbling so the chat area doesn't open

                var btn = $(this);
                var assignId = parseInt(btn.data("assignid"), 10);
                var typeId = parseInt(btn.data("typeid"), 10);

                // Only open dialog if it is a ticket (typeid 1) and ID exists
                if (typeId === 1 && !isNaN(assignId) && assignId > 0) {
                    me.vcV.showSingleTicketDialog(me.settings.blid, {
                        TicketID: assignId,
                        LoggerID: me.settings.blid,
                        readOnlyMode: true,
                        startEntry: null
                    });
                }
            });

            // Click handler on row (group) to open the chat and mark rows as read locally
            me.myHtml.list.entries.off("click", ".parent-row").on("click", ".parent-row", function (e) {
                // Ignore clicks on expand icons or info-icons to prevent overlapping actions
                if ($(e.target).closest(".info-assign").length > 0) return;

                var assignId = $(this).attr("data-assignid");
                var typeId = parseInt($(this).attr("data-typeid"), 10) || 1;
                if (!assignId) return;

                // Highlight the selected row
                me.myHtml.list.entries.find(".vc-list-item").removeClass("selected");
                $(this).addClass("selected");

                // Instantly remove unread style (bold font)
                $(this).removeClass("unread").css("font-weight", "normal");
                $(this).find(".vc-list-col-element, span, .type-text").css("font-weight", "normal");

                me._openChat(assignId, typeId);
            });

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _buildHtml: function () {
        /// <summary>
        /// This function builds the html structure
        /// </summary>
        var me = this;
        try {
            me.myHtml = { header: { topmenu: {} }, list: {}, chatArea: {} };

            // ---- body container ----
            // Flex container for side-by-side layout
            me.myHtml.bodyContainer = $("<div>").addClass("unccl-body-container").css({
                "display": "flex",
                "width": "100%",
                "gap": "15px"
            });

            // ---- left column setup ----
            // Create a wrapper column for the top menu and list (takes up 50% width)
            me.myHtml.leftColumn = $("<div>").addClass("unccl-left-column").css({
                "display": "flex",
                "flex-direction": "column",
                "flex": "1 1 60%",
                "box-sizing": "border-box"
            });

            // ---- top menu ----
            // Positioned at the top of the left column
            me.myHtml.header = me._setObj("div-comment-list-topmenu", "unccl-topmenu");
            me.myHtml.header.topmenu = me.myHtml.header; // Safeguard reference to prevent breaking existing dependencies
            var tm = me.myHtml.header.topmenu;

            // vcFilter Wrapper (limited to 60% of the left column width)
            tm.filterWrap = me._setObj("div-comment-list-filter-wrap", "unccl-filter-wrap vc-grid-2col");
            tm.filter = me._setObj("div-comment-list-filter", "vc-filter unccl-filter vc-grid-2col");
            tm.filterWrap.append(tm.filter);
            tm.append(tm.filterWrap);

            // Wrapper for "I am marked" checkbox
            tm.chkMarkedWrap = $("<div>").addClass("unccl-marked-wrap");
            tm.chkMarked = $("<input>").attr({ type: "checkbox", id: "chk-marked-only" }).addClass("unccl-marked-checkbox");
            tm.lblMarked = $("<label>").attr("for", "chk-marked-only").addClass("unccl-marked-label").text(me.specific.resources.onlyMyMarkings);
            tm.chkMarkedWrap.append(tm.chkMarked, tm.lblMarked);
            tm.append(tm.chkMarkedWrap);

            // checkbox for showing read comments (only visible to admins)
            if (me.specific.isAdmin) {
                tm.chkShowReadWrap = $("<div>").addClass("unccl-showread-wrap").css("display", "inline-flex").css("align-items", "center").css("gap", "6px").css("font-size", "1.1em").css("user-select", "none").css("margin-left", "10px");
                tm.chkShowRead = $("<input>").attr({ type: "checkbox", id: "chk-show-read" }).addClass("unccl-showread-checkbox").css("cursor", "pointer").css("margin", "0").css("width", "16px").css("height", "16px");
                tm.lblShowRead = $("<label>").attr("for", "chk-show-read").css("cursor", "pointer").text(me.specific.resources.showReadComments);
                tm.chkShowReadWrap.append(tm.chkShowRead, tm.lblShowRead);
                tm.append(tm.chkShowReadWrap);
            }

            // Append top menu directly to left column
            me.myHtml.leftColumn.append(me.myHtml.header);

            // ---- list setup ----
            // List spans 100% of its parent leftColumn wrapper
            me.myHtml.list = me._setObj("div-comment-list-list", "unccl-list vc-list").css({
                "border": "1px solid #ddd",
                "width": "100%",
                "box-sizing": "border-box"
            });

            // Initialize header row (w5 / w60 / w35 layout)
            me.myHtml.list.header = me._setListHeader("");
            var line = me._setListItem();
            line.column.append(me._setListElement("", "w5").css("text-align", "center").html("&nbsp;")); // info icon
            line.column.append(me._setListElement("", "w60").html(me.specific.resources.item)); // assigned object name
            line.column.append(me._setListElement("", "w35").html(me.specific.resources.comments)); // comments

            me.myHtml.list.header.append(line.item);
            me.myHtml.list.entries = me._setObj("entries", "vc-list-table");
            me.myHtml.list.append(me.myHtml.list.header, me.myHtml.list.entries);

            // Append list directly into the left column
            me.myHtml.leftColumn.append(me.myHtml.list);

            // ---- chat area setup ----
            // Right column spans 50% width and starts flush from the top
            me.myHtml.chatArea = $("<div class='vc-user-notification-comment-chat-area'></div>").css({
                "flex": "1 1 40%",
                "box-sizing": "border-box"
            });

            // Append left column and chat area into the body container
            me.myHtml.bodyContainer.append(me.myHtml.leftColumn, me.myHtml.chatArea);

            // Append body container directly to root
            me.myRoot.append(me.myHtml.bodyContainer);

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _fetch: function () {
        var me = this;
        try {
            me._setLoadingIcon(me.myHtml.list.entries);

            var start = me.options.parameter && me.options.parameter.StartDate ? me.options.parameter.StartDate : "";
            var end = me.options.parameter && me.options.parameter.EndDate ? me.options.parameter.EndDate : "";
            var showAllUser = me.options.parameter && typeof me.options.parameter.ShowAllUser !== "undefined" ? me.options.parameter.ShowAllUser : false;
            var filteredLoggerId = me.options.parameter && typeof me.options.parameter.LoggerId !== "undefined" ? me.options.parameter.LoggerId : me.settings.blid;
            var showRead = me.specific.isAdmin && me.myHtml.header.topmenu.chkShowRead ? me.myHtml.header.topmenu.chkShowRead.prop("checked") : false;

            me.getData({ TypeId: 3, LoggerId: filteredLoggerId, StartDate: start, EndDate: end, ShowAllUser: showAllUser, ShowRead: showRead }, function (result) {
                if (!result) {
                    me.myHtml.list.entries.html($("<br>")).append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                    return;
                }
                me._generateList(result);
                me._setHeightsAndWidths();
            });

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _getTypeConfig: function (typeId) {
        /// <summary>
        /// This function returns the type configuration (name and icon) based on the typeId
        /// </summary>
        var types = {
            1: { name: "Ticket", icon: "fa-regular fa-ticket" },
            2: { name: "Signal", icon: "fa-regular fa-bolt" }
        };
        return types[typeId] || { name: "Eintrag", icon: "fa-regular fa-file" };
    },

    _generateList: function (result) {
        var me = this;
        try {
            var entries = me.myHtml.list.entries;
            entries.empty();

            var rows = result.rows || result;
            if (!Array.isArray(rows) || rows.length === 0) {
                entries.html($("<br>")).append($("<div>").addClass("note").html(me.specific.resources.noEntriesExist));
                return;
            }

            // 1. Group comments by assignId
            var groups = {};
            var groupOrder = [];

            $.each(rows, function (key, row) {
                var assignId = row.assignId || row.assignid;
                var typeId = parseInt(row.typeid || row.typeId || row.TypeId, 10);
                if (isNaN(typeId)) {
                    typeId = 1; // Default fallback to Ticket (1)
                }
                var groupKey = assignId ? assignId.toString() : "no-assign";

                // Check if this specific row is unread (cast to boolean)
                var isUnread = row.is_unread === true || row.is_unread === "True" || row.is_unread === "true" || row.isunread === true;

                if (!groups[groupKey]) {
                    groups[groupKey] = {
                        assignId: assignId || null,
                        typeId: typeId,
                        assignName: row.operation_name || row.operationName || row.assignName || row.assignname || "",
                        projectName: row.projectName || row.projectname || "", // save project name for group header
                        comments: [],
                        hasUnread: false
                    };
                    groupOrder.push(groupKey);
                }

                if (isUnread) {
                    groups[groupKey].hasUnread = true;
                }
                groups[groupKey].comments.push(row);
            });

            // 2. Generate HTML elements per group (Only 1 row per group)
            $.each(groupOrder, function (idx, groupKey) {
                var group = groups[groupKey];
                var commentsToShow = group.comments.slice(-3); // Get last 3 comments

                var rowLine = me._setListItem();
                rowLine.item.addClass("parent-row")
                    .attr("data-id", group.assignId || "")
                    .attr("data-assignid", group.assignId || "")
                    .attr("data-typeid", group.typeId)
                    .data("comments-data", commentsToShow); // Save raw comments list for filtering

                // Set styling dynamically based on read/unread status
                if (group.hasUnread) {
                    rowLine.item.addClass("unread").css("font-weight", "bold");
                } else {
                    rowLine.item.css("font-weight", "normal");
                }

                // column 1: info icon
                var infoIconCol = me._setListElement("", "w5").css("text-align", "center");
                if (parseInt(group.typeId, 10) === 1) {
                    var icon = me._getTypeConfig(group.typeId);
                    var infoIcon = $("<i class='vc-list-icon popup " + icon.icon + " color-font-secondary info-assign' style='cursor:pointer; float: none !important; display: inline-block !important; margin: 0 !important;'></i>")
                        .data("assignid", group.assignId)
                        .data("typeid", group.typeId)
                        .attr("title", me.specific.resources.information);
                    infoIconCol.html(infoIcon);
                } else {
                    infoIconCol.html("&nbsp;");
                }
                rowLine.column.append(infoIconCol);

                // column 2: assigned object name (type + id + optional name)
                var displayId = group.assignId || "-";
                var displayName = group.assignName || "";
                var typeConfig = me._getTypeConfig(group.typeId);
                var typeText = typeConfig.name + " " + displayId + (displayName ? ": " + displayName : "");

                // Get the filtered LoggerId from the instantiation parameters
                var filteredLoggerId = me.options.parameter && typeof me.options.parameter.LoggerId !== "undefined" ? me.options.parameter.LoggerId : me.settings.blid;

                // Append project name in parentheses if viewing comments across all projects (-1)
                if (parseInt(filteredLoggerId, 10) === -1 && group.projectName) { typeText += " (" + group.projectName + ")"; }

                typeText = me._decodeHtml(typeText);

                var parentWeight = group.hasUnread ? "bold" : "normal";
                var parentContent = $("<span>").addClass("type-text").css({ "font-weight": parentWeight, "font-size": "1.1em" }).text(typeText);

                rowLine.column.append(me._setListElement("", "w60").html(parentContent));

                // column 3: comments (show up to 3 with preview and author)
                var commentsContainer = $("<div>").css({ "font-size": "0.95em" });

                $.each(commentsToShow, function (cIdx, comment) {
                    if (cIdx > 0) {
                        commentsContainer.append("<br>");
                    }
                    var textVal = comment.text || comment.Text || "";
                    var authorVal = comment.authorname || comment.AuthorName || "";

                    // max preview length for comments
                    var maxCommentLength = 100;
                    var hasNewline = false;

                    var brIndex = textVal.toLowerCase().indexOf("<br");
                    if (brIndex > -1) {
                        textVal = textVal.substring(0, brIndex);
                        hasNewline = true;
                    }

                    var newlineIndex = textVal.search(/[\r\n]/);
                    if (newlineIndex > -1) {
                        textVal = textVal.substring(0, newlineIndex);
                        hasNewline = true;
                    }

                    // we cut the text of the comment if length is too long
                    if (textVal.length > maxCommentLength) {
                        textVal = textVal.substring(0, maxCommentLength) + "...";
                    } else if (hasNewline) {
                        textVal = textVal + "...";
                    }

                    // Dynamically set font weight for each comment in the preview list
                    var isCommentUnread = comment.is_unread === true || comment.is_unread === "True" || comment.is_unread === "true" || comment.isunread === true;
                    var commentWeight = isCommentUnread ? "bold" : "normal";

                    var singleCommentSpan = $("<span>");
                    if (authorVal) {
                        singleCommentSpan.append($("<span>").addClass("smaller").text(authorVal + ": ").css("font-weight", commentWeight));
                    }
                    singleCommentSpan.append($("<span>").text(textVal).css("font-weight", commentWeight));
                    commentsContainer.append(singleCommentSpan);
                });

                if (commentsToShow.length === 0) {
                    commentsContainer.html("&nbsp;");
                }

                rowLine.column.append(me._setListElement("", "w35").html(commentsContainer));

                entries.append(rowLine.item);
            });

            me._setAltListStyle(entries);

        } catch (e) { me._writeErr(e); }
    },

    _openChat: function (assignId, typeId) {
        /// <summary>
        /// This function opens the chat area for the selected assignId and typeId
        /// </summary>
        var me = this;
        try {
            if (!assignId) return;

            // Recalculate heights and widths
            me._setHeightsAndWidths();

            // Destroy previous widget instance if it exists to ensure a clean reload state
            if (me.myHtml.chatArea[0] && me.myHtml.chatArea[0].UserNotificationComments) {
                try { me.myHtml.chatArea.UserNotificationComments("destroy"); } catch (e) { }
            }

            me._setLoadingIcon(me.myHtml.chatArea);

            // Instantiate the UserNotificationComments widget
            me.myHtml.chatArea.UserNotificationComments({
                invokeType: "addVisualBase",
                blid: me.settings.blid,
                parameter: {
                    LoggerId: me.settings.blid,
                    AssignId: parseInt(assignId, 10),
                    AssignTypeId: parseInt(typeId, 10) || 1
                }
            });

        } catch (e) { me._writeErr(e); }
    },

    _setHeightsAndWidths: function () {
        /// <summary>
        /// This function calculates and sets the heights of the list and chat area based on the visual height
        /// </summary>
        var me = this;
        try {
            var h = me._getVisualHeight();

            // Left column list wrapper height (total height minus filter menu height)
            var headerH = me.myHtml.header.outerHeight(true) || 0;
            var listWrapperH = h - headerH - 10;

            me.myHtml.list.css("height", listWrapperH);

            if (me.myHtml.list.entries) {
                var listHeaderH = me.myHtml.list.header.outerHeight(true) || 0;
                var entriesH = listWrapperH - listHeaderH - 10;
                me.myHtml.list.entries.css("height", entriesH).css("maxHeight", entriesH).css("overflow-y", "auto");
            }

            // Match chat area height to the full visual height as it starts flush from the top
            if (me.myHtml.chatArea) {
                me.myHtml.chatArea.css({ "height": h, "overflow": "hidden" });
            }
        } catch (e) { me._writeErr(e); }
    },

    _filterEntries: function () {
        /// <summary>
        /// This function filters the list entries based on the text filter and "I am marked" checkbox
        /// </summary>
        var me = this;
        try {
            // Retrieve text tags from vcFilter
            var tags = me.myHtml.header.topmenu.filter.vcFilter("getFilter");

            // Retrieve "I am marked" checkbox state
            var showOnlyMarked = me.myHtml.header.topmenu.chkMarked.is(":checked");
            var currentUid = parseInt(me.specific.uid, 10);

            // Loop through each row
            me.myHtml.list.entries.find(".parent-row").each(function () {
                var parent = $(this);
                var commentsData = parent.data("comments-data") || [];

                // 1. Match text filtering
                var matchesText = true;
                if (tags && tags.length > 0) {
                    var combinedText = parent.text().toLowerCase();

                    for (var i = 0; i < tags.length; i++) {
                        if (combinedText.indexOf(tags[i].toLowerCase()) === -1) {
                            matchesText = false;
                            break;
                        }
                    }
                }

                // 2. Match MarkedUser filtering
                var matchesMarked = true;
                if (showOnlyMarked) {
                    matchesMarked = false;

                    // Check if current UID is present in the JSON arrays of the comments
                    for (var c = 0; c < commentsData.length; c++) {
                        var comment = commentsData[c];
                        var mu = comment.markeduser || comment.MarkedUser;
                        var markedUsers = [];
                        if (mu) {
                            if (Array.isArray(mu)) {
                                markedUsers = mu;
                            } else if (typeof mu === "string") {
                                try { markedUsers = JSON.parse(mu); } catch (e) { }
                            }
                        }

                        if (markedUsers.indexOf(currentUid) !== -1 || markedUsers.indexOf(String(currentUid)) !== -1) {
                            matchesMarked = true;
                            break;
                        }
                    }
                }

                if (matchesText && matchesMarked) {
                    parent.show();
                } else {
                    parent.hide();
                }
            });

            // Reapply alternating row colors to all visible elements
            me._setAltListStyle(me.myHtml.list.entries);

        } catch (e) { me._writeErr(e); }
    },

    _decodeHtml: function (text) {
        if (!text) return "";
        var txt = document.createElement("textarea");
        txt.innerHTML = text;
        return txt.value;
    },

    _setAltListStyle: function (entries) {
        /// <summary>
        /// This function applies alternating row colors to visible list items
        /// </summary>
        var me = this;
        try {
            if (entries) {
                // Remove all alt classes first
                entries.find(".vc-list-item").removeClass("alt");
                // Add alt class to visible rows alternately
                entries.find(".vc-list-item:visible:even").addClass("alt");
            }
        } catch (e) { me._writeErr(e); }
    },

    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                me.myHtml.header.hide();
                me.myHtml.list.hide();
            }
            return true;
        } catch (e) {
            me._writeErr(e); return false;
        }
    }
});